import { useDataSubmit, useDataValue } from 'Simple/Data'

export function useOnChange(props) {
  let submit = useDataSubmit({
    context: 'task',
    viewPath: props.viewPath,
  })

  let action_id = useDataValue({
    context: 'action',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    if (value) {
      submit({
        type: 'set_task_action_resource_id',
        action_id,
        resource_id: value,
      })
    }
  }
}
